import React from 'react'
import api, { METHODS } from './api'

import GlobalNotification from 'live/services/global-notification'
import { Notification } from '../common/components/Notification/Notification'
import i18n from 'live/services/i18n'
import { MailJobSettings, Recipient } from '../common/types/form'

interface ResponseType {
    success: boolean
    error: string
    title?:string
    status?:string
}

export default async function testReportWithContextRecipient(
    uid: string,
    timespan: string,
    recipientGroups: Recipient[],
    testRecipients: string[]
): Promise<{ success: boolean; status: string }> {
    try {
        const res = await api<ResponseType>(
            `manualReport/${uid}`,
            METHODS.POST,
            JSON.stringify({
                recipients: recipientGroups,
                span: timespan,
                dateRef: null,
                isTest: true,
                testRecipients
            } as MailJobSettings)
        )

        if (!res.success) {
            GlobalNotification.error(
                <Notification title={i18n('Error trying to run a test report: ')}>{'unknown error'}</Notification>,
                20
            )

            console.error(res)
        } else {
            GlobalNotification.success(<Notification title={i18n('Tested successfully!')} />, 20)
        }

        return {
            success: res.success,
            status: res.status ?? "-"
        }
    } catch (error) {
        GlobalNotification.error(
            <Notification title={i18n('Error trying to to run a test report:')}>{error}</Notification>,
            20
        )

        console.error(error)

        return {
            success: false,
            status: error
        }
    }
}
